import "./style.scss";
import "./style-mob.scss";
import { useState } from "react";
import Tabs from "@/src/components/Tabs/Tabs";
import AdmissionProcessSteps from "./AdmissionProcessSteps/AdmissionProcessSteps";
import { admissionProcessTabs } from "@/src/constants/admission-process";
import { admissionProcessStepsOnCampus, admissionProcessStepsOnline } from "@/src/constants/admission-process";

const AdmissionProcess = () => {
  const [currentTab, setCurrentTab] = useState<string>("on-campus");

  return (
    <div className="admission-process container section-margin-top">
      <div className="admission-process-header">
        <Tabs title="Процесс поступления" tabs={admissionProcessTabs} currentTab={currentTab} setCurrentTab={setCurrentTab} />
      </div>
      {currentTab === "on-campus" && (
        <AdmissionProcessSteps steps={admissionProcessStepsOnCampus} link={"/single-page/education-personal"} />
      )}
      {currentTab === "online" && <AdmissionProcessSteps steps={admissionProcessStepsOnline} link={"/single-page/education-remotely"} />}
    </div>
  );
};

export default AdmissionProcess;
